import React, { PropTypes } from 'react';
import MediaQuery from 'react-responsive';
import omit from 'lodash/omit';

import styled from 'styled-components';

export const breakpoints = {
  desktop: '(min-width: 1025px)',
  ipadProLandscape:
    'only screen and (min-device-width : 1024px) and (max-device-width : 1024px) and (min-device-height : 1366px) and (max-device-height : 1366px) and (min-width: 1366px) and (max-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2)',
  ipadProPortrait:
    'only screen and (min-device-width : 1024px) and (max-device-width : 1024px) and (min-device-height : 1366px) and (max-device-height : 1366px) and (min-width: 1024px) and (max-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2)',
  mobileTablet: '(max-width: 1024px)',
  mobile: '(max-width: 680px)',
  tablet: '(min-width: 681px) and (max-width: 1024px)',
  tabletDesktop: '(min-width: 681px)',
  screen: '(min-width: 1400px)',
  averageMobile: '(max-width: 480px)',
  extraSmallMobile: '(max-width: 320px)',
};

/**const ResponsiveWrapper = styled.div`
  display: none;
  @media${props => breakpoints[props.name]} {
    display: inline;
    display: initial;
  }
`;**/

const Breakpoint = props => {
  const { children, name } = props;
  const breakpoint = name || 'desktop';
  // return <ResponsiveWrapper name={breakpoint}>{children}</ResponsiveWrapper>;

  const newProps = omit(props, ['children', 'name']);

  return (
    <MediaQuery query={breakpoints[breakpoint]} {...newProps}>
      {children}
    </MediaQuery>
  );
};

export default Breakpoint;

// export default function Breakpoint(props) {
//   const breakpoint = breakpoints[props.name] || breakpoints.desktop;
//
//   const ChildComponent = props.children || <span />;
//
//   return (
//     <MediaQuery {...props} query={breakpoint}>
//       {ChildComponent}
//     </MediaQuery>
//   );
// }
Breakpoint.propTypes = {
  name: PropTypes.string,
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/utils/breakpoints.js